const getValueLabelByEmail = ({
    email,
}: {
    email: string
}): string => {
    return `${email}`
}

export default getValueLabelByEmail
